import { Method } from 'axios';
import { apiCall } from '@/utility/api/apiUtils';
import { API_METHOD_PUT, API_UPDATE_VARIATION } from '@/constants/apiConstants';
import { generateHash } from '@/utility/auth/generateHashValue';

export interface UpdateVariationPayload {
  title: string;
  description: string;
  date: string;
  sections: Array<{
    uuid?: string;
    title: string;
    description: string;
    section_type: number;
    display_order: number;
    is_active: boolean;
    is_approved: boolean;
    parent_section_id: string | null;
    column_visibility: {
      product: boolean;
      qty: boolean;
      price: boolean;
      tax: boolean;
      discount: boolean;
      total: boolean;
    };
    products: any[];
    total_items?: number;
    subtotal?: number;
    cost?: number;
  }>;
}

export interface UpdateVariationResponse {
  status: string;
  data?: any;
  message?: string;
}

export const updateVariation = async (
  jobUuid: string,
  variationUuid: string,
  payload: UpdateVariationPayload,
): Promise<UpdateVariationResponse> => {
  const method: Method = API_METHOD_PUT;
  const url = API_UPDATE_VARIATION(jobUuid, variationUuid);
  const data = payload;

  // Convert JSON object to string
  const jsonString = JSON.stringify(data);
  const additionalHeaders = {
    hash: generateHash(jsonString),
  };

  try {
    const response = await apiCall({
      method,
      url,
      data,
      headers: additionalHeaders,
    });
    return response; // Return the response data for further use
  } catch (error) {
    throw error; // Re-throw the error to be handled by the caller
  }
};
